import { render, staticRenderFns } from "./LiquidacionesPage.vue?vue&type=template&id=b6fe87de"
import script from "./LiquidacionesPage.vue?vue&type=script&lang=js"
export * from "./LiquidacionesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports